import React, { useEffect } from 'react';
import { HeadingTwo } from '@marty-js/design/src/atoms/h2';
import { ItemCtaSimple } from '@marty-js/design/src/molecules/item-cta-simple';
import styled from 'styled-components';
import { useTranslation } from '@marty-js/design/src/utils/translation';
import { Cta } from '@marty-js/design/src/molecules/cta';
import type { ItemSidebarComponentItemSelectionType } from '../types';
import { generateCtaByTypeCta } from '../../../utils/typeCta';

const ListItemRow = styled.ul`
  display: flex;
  flex-direction: column;
`;

const ItemSelection: React.FC<ItemSidebarComponentItemSelectionType> = ({ data, setIsIamSticky, isFirst }) => {
  const t = useTranslation();
  useEffect(() => {
    setIsIamSticky(false);
  }, [setIsIamSticky]);

  const { title, typeCta, titleMainCta, urlMainCta } = data.info;

  return (
    <>
      <HeadingTwo className="mod-without-mt" as="div">
        {title}
      </HeadingTwo>
      <ListItemRow>
        {data?.items?.genericItemList?.map((item) => {
          if (!item?.id) {
            return null;
          }

          const imageProps = {
            imageId: item.imageId,
            alt: item.title,
          };

          const ctaText = generateCtaByTypeCta(typeCta, item, t);
          const linkProps = ctaText
            ? {
                href: item.urlCta ?? item.url,
                text: ctaText,
              }
            : null;

          return (
            <ItemCtaSimple
              small={false}
              href={item.url}
              key={item.id}
              title={item.title}
              image={imageProps}
              cta={linkProps}
              lazy={!isFirst}
              subtitle={item.title}
            />
          );
        })}
        {titleMainCta && urlMainCta ? (
          <Cta className="mod-sm" title={titleMainCta} href={urlMainCta}>
            {titleMainCta}
          </Cta>
        ) : null}
      </ListItemRow>
    </>
  );
};

export default ItemSelection;
